<template>
  <div class="content-main">

    <div class="shanzha" v-if="!submit_result">

      <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <span>{{$store.state.siteSlogan}}</span>
      </div>

      <div class="message">

        <div class="info-input flex-box receiver">
          <div class="input-label">To：</div>
          <input class="username-content" placeholder="请填写收信人昵称" v-model="receiver" />
        </div>

        <div class="info-input flex-box message-content">
          <div class="input-label">内容</div>
          <textarea class="message-text" rows="6" maxlength="140" placeholder="请填写信件内容" v-model="info"></textarea>
        </div>

        <div class="contribute-and-count flex-box">
          <van-checkbox v-model="contribute" label-position="left" icon-size="18px"><span class="hint-contribute">投稿至广场</span></van-checkbox>
          <span>字数：{{info.length}}/ 140</span>
        </div>

        <div class="info-input flex-box sender">
          <div class="input-label">From：</div>
          <input class="username-content" placeholder="请填写寄信人昵称" v-model="sender" />
        </div>

        <div class="info-input flex-box postdate">
          <div class="input-label">收信时间：</div>
          <div @click="showDatePopup()"><van-field class="postdate-text" v-model="schedule" placeholder="请选择期望收信日期" readonly/></div>

          <van-popup class="pop-datepicker" v-model="showDatePicker">
            <van-datetime-picker class="pop-datetime-picker" v-model="postDate" type="date" :min-date="minDate" :max-date="maxDate"
              :formatter="formatter" @cancel="hideDatePopup()" @confirm="convertPostDate()"/>
          </van-popup>

          <van-dialog v-model="showDialog" title="" show-cancel-button
            cancelButtonText="修改日期" cancelButtonColor="#969799" confirmButtonColor="#576b95"
            @confirm="confirmDateConfirmDialog()" @cancel="cancelDateConfirmDialog()">
            <div class="date-dialog-msg"><span>请确认期望收信时间为：</span><span class="dialog-date">{{ getDialogDate() }}</span></div>
          </van-dialog>

        </div>

        <!-- <div class="schedule-hint">* 系统会在每月初寄出收信时间为当月的信件</div> -->
        <div class="schedule-hint">提示：纸质信件通过快递寄出，实际收件日期可能会与你填写的期望收信日期前后相差几天。</div>

        <div class="btn-submit" @click="next()">下一步</div>
      </div>

      <div class="postcard-rule-v2 flex-box" @click="goPostcardExample()">
        <span class="gesture-right">👉</span><span class="rule-text">点击查看纸质信实拍图</span>
      </div>

    </div>

    <div class="btn-check flex-box" @click="goBack()"><div class="btn-txt flex-box"><div>返回</div><div>首页</div></div></div>

    <van-popup v-model="loading" class="pop-loading" :close-on-click-overlay="false">
      <div class="loading">
        <span>正在拼命提交中，请稍等片刻～</span>
        <van-loading type="spinner" />
      </div>
    </van-popup>

    <van-popup class="pop-mailway" v-model="mailOptionsPopup" position="bottom">
      <div>
        <div class="payway-title">选择信件类型</div>
        <div>
          <div class="price-item flex-box" :style="{'background': getPayItemBackground('postcard'), 'borderColor': getBorderColor('postcard')}" @click="pickPayItem('postcard')">
            <div>
              <div class="flex-box">
                <div :style="{'color': getPayPriceColor('postcard')}">纸质明信片 / 29.9元</div>
                <!-- <div class="tags flex-box">
                  <div class="tag" :style="{'color': getPayTagColor('postcard'), 'borderColor': getPayTagBorderColor('postcard')}">可寄给任何人</div>
                  <div class="tag" :style="{'color': getPayTagColor('postcard'), 'borderColor': getPayTagBorderColor('postcard')}">纸质明信片</div>
                </div> -->
              </div>
              <div class="flex-box tags-newline">
                <div class="tag no-margin-left" :style="{'color': getPayTagColor('postcard'), 'borderColor': getPayTagBorderColor('postcard')}">可寄给任何人</div>
                <div class="tag" :style="{'color': getPayTagColor('postcard'), 'borderColor': getPayTagBorderColor('postcard')}">纸质明信片</div>
                <div class="tag" :style="{'color': getPayTagColor('postcard'), 'borderColor': getPayTagBorderColor('postcard')}"><span class="original-cost">原价49.9元</span></div>
                <!-- <div class="tag" :style="{'color': getPayTagColor('postcard'), 'borderColor': getPayTagBorderColor('postcard')}">特价优惠</div> -->
              </div>
              <!-- <div class="price-remark" :style="{'color': getPayPriceColor('postcard')}">• 可以参加3期活动，每期都享有优先匹配权，剩余未使用期数随时可退。</div> -->
            </div>
            <img class="icon-check" v-if="!checkMailPostcard" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
            <img class="icon-check" v-if="checkMailPostcard" src="https://static.huiyiji520.com/icon-checked-b17e94-1667907777.png">
          </div>

          <div class="price-item flex-box" :style="{'background': getPayItemBackground('wechat'), 'borderColor': getBorderColor('wechat')}" @click="pickPayItem('wechat')">
            <div class="flex-box">
              <div :style="{'color': getPayPriceColor('wechat')}">电子版 / 免费</div>
              <div class="tags flex-box">
                <div class="tag" :style="{'color': getPayTagColor('wechat'), 'borderColor': getPayTagBorderColor('wechat')}">仅可寄给自己</div>
                <div class="tag" :style="{'color': getPayTagColor('wechat'), 'borderColor': getPayTagBorderColor('wechat')}">电子版</div>
              </div>
            </div>
            <img class="icon-check" v-if="!checkMailWechat" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
            <img class="icon-check" v-if="checkMailWechat" src="https://static.huiyiji520.com/icon-checked-b17e94-1667907777.png">
          </div>
        </div>
        <div class="pay-confirm" @click="submit()">下一步</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { Dialog, Toast, Popup, Checkbox, Loading, Icon, Field, DatetimePicker } from 'vant'

export default{
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker
  },
  data(){
    return {
      info: '',
      receiver: '',
      sender: '',
      loading: false,
      contribute: true,
      submit_result: false,
      schedule: '',
      showDatePicker: false,
      showDialog: false,
      postDate: this.getNextMonthDate(),
      minDate: this.getNextMonthDate(),
      maxDate: new Date(2037, 11, 31),
      mailOptionsPopup: false,
      checkMailWechat: false,
      checkMailPostcard: true,
      pickedMailOption: 'postcard'
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    next(){
      if(this.receiver.trim().length == 0){
        Toast('请填写收信人昵称')
      }else if(this.sender.trim().length == 0){
        Toast('请填写寄信人昵称')
      }else if(this.info.trim().length == 0){
        Toast('请输入信件内容')
      }else if(this.info.trim().length < 10){
        Toast('信件内容不能少于10个字')
      }else if(this.schedule.length == 0){
        Toast('请选择收信时间')
      }else{
        // this.showMailOptions()
        this.$store.commit('setMailDraft', {
          sender: this.sender.trim(),
          receiver: this.receiver.trim(),
          content: this.info.trim(),
          square: this.contribute ? 1 : 0,
          schedule: Date.parse(this.postDate) / 1000
        })
        this.handleRouter('/parcel_revise/' + this.$route.params.id)
      }
    },
    submit(){
      if(!this.pickedMailOption){
        Toast('请选择信件类型')
      }else if(this.loading == true){
        return
      }else if(this.pickedMailOption == 'wechat'){
        this.submitMailWechat()
      }else if(this.pickedMailOption == 'postcard'){
        this.$store.commit('setMailDraft', {
          sender: this.sender.trim(),
          receiver: this.receiver.trim(),
          content: this.info.trim(),
          square: this.contribute ? 1 : 0,
          schedule: Date.parse(this.postDate) / 1000
        })
        this.handleRouter('/parcel_create')
      }
    },
    submitMailWechat(){
      this.loading = true
      let openid = this.$store.state.userinfo.openid
      let sender = this.sender.trim()
      let receiver = this.receiver.trim()
      let content = this.info.trim()
      let square = this.contribute ? 1 : 0
      let schedule = Date.parse(this.postDate) / 1000
      let referal = this.$store.state.referal
      this.$api.post('/momentbox/create_mail_in_wechat', {openid: openid, sender: sender, receiver: receiver, content: content, square: square, schedule: schedule, referal: referal}, res => {
        if(res.code == 200){
          // this.handleRouter('/mail_submitted_success/wechat')
          this.$router.replace("/mail_submitted_success/wechat")
        }
        this.loading = false
      })
    },
    goHome(){
      this.$router.replace("/?referal=" + this.$store.state.referal)
    },
    showMailOptions(){
      this.mailOptionsPopup = true
    },
    getPayItemBackground(level){
      return this.pickedMailOption == level ? '#F5EFFB' : '#f7f7f7'
    },
    getBorderColor(level){
      return this.pickedMailOption == level ? '#b17e94' : '#f7f7f7'
    },
    getPayPriceColor(level){
      return this.pickedMailOption == level ? '#b17e94' : '#737373'
    },
    getPayTagColor(level){
      return this.pickedMailOption == level ? '#b17e94' : '#8d8b8b'
    },
    getPayTagBorderColor(level){
      return this.pickedMailOption == level ? '#b17e94' : '#c0bebe'
    },
    pickPayItem(level){
      this.pickedMailOption = level
      if(level == "wechat"){
        this.checkMailWechat = true
        this.checkMailPostcard = false
      }else if(level == "postcard"){
        this.checkMailWechat = false
        this.checkMailPostcard = true
      }
    },
    showDatePopup(){
      this.showDatePicker = true
    },
    hideDatePopup(){
      this.showDatePicker = false
    },
    showDateConfirmDialog(){
      this.showDialog = true
    },
    cancelDateConfirmDialog(){
      this.showDialog = false
    },
    confirmDateConfirmDialog(){
      this.showDialog = false
      this.convertPostDate()
    },
    getDialogDate(){
      let time = new Date(this.postDate)
      let date = `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日`
      // let date = `${time.getFullYear()}年${time.getMonth() + 1}月`
      return date
    },
    convertPostDate(){
      let time = new Date(this.postDate)
      this.schedule = `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日`
      // this.schedule = `${time.getFullYear()}年${time.getMonth() + 1}月`
      this.showDatePicker = false
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      }
      return value;
    },
    getNextDayDate(){
      let date = new Date()
      date.setDate(date.getDate() + 1)
      return date
    },
    getDayAfterTommorrow(){
      let date = new Date()
      date.setDate(date.getDate() + 2)
      return date
    },
    getNextMonthDate(){
      let date = new Date()
      date.setDate(1)
      date.setMonth(date.getMonth() + 1)
      return date
    },
    goBack(){
      let _this = this
      Dialog.confirm({
        title: '提醒',
        message: '退出以后，草稿不会保存。',
        confirmButtonText: '继续填写',
        confirmButtonColor: 'black',
        cancelButtonText: '退出'
      })
      .then(() => {
        // on confirm
      })
      .catch(() => {
        // on cancel
        _this.$router.go(-1)
      });
    },
    setReferal(){
      let searchParams = new URLSearchParams(window.location.search)
      if(searchParams.get("referal")){
        this.$store.commit('setReferal', { referal: searchParams.get("referal") })
      }
    },
    goPostcardExample(){
      window.location.href = "https://mp.weixin.qq.com/s/QR69Ds0YQUR5TaRBL7pS2Q"
    },
    getMailDetail(){
      let id = this.$route.params.id
      this.$api.get('/momentbox/get_mail_detail', {id: id}, res => {
        if(res.code == 200){
          let mail = res.mail
          this.info = mail.content
          this.sender = mail.sender
          this.receiver = mail.receiver
          this.contribute = mail.square
          this.postDate = new Date(mail.schedule * 1000)
          this.convertPostDate()
        }
      })
    }
  },
  mounted(){
    // this.setReferal()
    this.getMailDetail()
  }
}
</script>

<style scoped>
.content-main{min-height:100vh;background-color: #f8f8f8;color:#b17e94;}
.shanzha{padding:20px;}
.logo-and-wish{padding:15px 0px;font-size:30px;margin-bottom:20px;}
.logo{height:150px;width:150px;border-radius:150px;margin-right:35px;}
.btn-check{
  width:120px;height:120px;border-radius:120px;background:#b17e94;position:fixed;
  bottom:100px;right:40px;color:#fff;justify-content:center;
}
.btn-txt{
  flex-direction: column;justify-content:center;width:102px;height:102px;border:2px solid #fff;
  border-radius:102px;font-size:25px;
}

.message {background:#fff;padding:40px;}
.message .info-input{}
.message .input-label{width:60px;text-align: left;font-size:26px;margin-right:10px;}
.message .message-content{align-items:flex-start;padding-top:15px;}
.message .message-content .input-label{line-height:2.0;}
.message .message-content .message-text{font-size:26px;flex-grow:1;border:none;color:#333;line-height:2.0;}
.message .contribute-and-count{font-size:24px;justify-content:space-between;color:#969799;padding-bottom:15px;}
.message .contribute-and-count .hint-contribute{color:#969799;font-size:24px;}
.message .receiver{border-bottom:1px solid #b17e94;padding-bottom:15px;}
.message .sender{border-top:1px solid #b17e94;padding-top:20px;}
.message .username-content{font-size:26px;flex-grow:1;border:none;color:#333;}
.message .postdate{margin-top:25px;}
.message .postdate .input-label{width:150px;}
.message .pop-datepicker{width:70%;}
.message .postdate .postdate-text{font-size:26px;background:#fafafa;padding:5px;padding-left:20px;color:#969799;border-radius:5px;border:1px solid #d2d6de;}
.message .date-dialog-msg{padding:80px 20px;font-size:25px;text-align:center;color:#666;}
.message .dialog-date{color:#333;font-weight:bold;}
.message .schedule-hint{color:#666;font-size:24px;text-align:left;margin-top:15px;}
.btn-submit{background:#b17e94;color:#fff;font-size:28px;font-weight:340;height:80px;line-height:80px;margin-top:50px;}

*::-webkit-input-placeholder {color: #969799;font-size:24px;}
*:-moz-placeholder {/* FF 4-18 */color: #969799;font-size:24px;}
*::-moz-placeholder {/* FF 19+ */color: #969799;font-size:24px;}
*:-ms-input-placeholder {/* IE 10+ */color: #969799;font-size:24px;}

.pop-loading{width:70%;padding:20px;margin:0 auto;}
.pop-loading{background:rgba(255,255,255,0);color:#fff;}
.content-main .loading .van-loading{margin:0 auto;margin-bottom:15px;margin-top:30px;}
.content-main .loading{ font-size:23px;padding:20;text-align:center;}

.pop-mailway{font-size:32px;padding:20px;color:#737373;font-weight:normal;}
.pop-mailway .payway-title{margin-bottom:25px;}
.pop-mailway .price-item{
  background:#f7f9fc;margin-bottom:25px;padding:25px 20px;color:#737373;font-size:28px;
  justify-content:space-between;border-radius:10px;border:4px solid #f7f7f7;
}
.pop-mailway .price-item .icon-check{width:45px;height:45px;}
.pop-mailway .tag{font-size:20px;margin-left:15px;background:#fff;color:#8d8b8b;padding:2px 8px;border-radius:10px;border:2px solid #c0bebe;}
.pop-mailway .tag.no-margin-left{margin-left:0px;}
.pop-mailway .tags-newline{margin-top:10px;}
.pop-mailway .original-cost{text-decoration:line-through;}
.pop-mailway .price-remark{font-size:20px;text-align:left;padding-right:20px;margin-top:10px;}
.pop-mailway .pay-confirm{background:#b17e94;color:#fbfbfb;padding:20px;border-radius:10px;}
@media (max-height: 500px) {
  .btn-check { display: none; }
}

.postcard-rule-v2{margin-top:20px;padding-left:20px;justify-content: flex-start;}
.postcard-rule-v2 .gesture-right{font-size:36px;margin-right:10px;}
.postcard-rule-v2 .rule-text{color:#666;font-size:24px;border-bottom:1px dashed #666;}
</style>
